import React, { useEffect, useState } from "react";
import moment from "moment";
import { Row, Col, Button } from "react-bootstrap";
import { Input, Divider, Select } from "antd";
import { ConfirmFinancialProductForm } from "./ConfirmFInancialProduct.js";
import { getLoanDetails, getAllLoans, getLoansByUser, getLatestLoanForBeekeeper } from "../../../services/loanService";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";

const readCookie = require("../cookie.js").readCookie;
const { Option } = Select;

const initialState = {

  loan: {
    Amount: "",
    interestRate: "",
    processingFee: "",
    moratorium: "",
    Tenure: "",
    repaymentDuration: "",
    modeOfApplication: "",
    appliedToBank: "",
    branchIFSC: "",
    dateOfApplication: "",
    dateOfSanction: "",
    dateOfDisbursement: "",
    dateOfRejection: "",
    status: "",
    importantInfo: "",
    disbursedTo: "",
    files: [],
    proofOfSanction: [],
    disbursedAmount: '',
    proofOfDisbursement: [],
  },
  grant: {
    Amount: "",
    modeOfApplication: "",
    appliedToBank: "",
    branchIFSC: "",
    dateOfApplication: "",
    dateOfSanction: "",
    dateOfDisbursement: "",
    dateOfRejection: "",
    status: "",
    importantInfo: "",
    disbursedTo: "",
    files: [],
    proofOfSanction: [],
    proofOfDisbursement: [],
    disbursedAmount: "",
  },
  self_investment: {
    Amount: "",
    isTransferred: "",
    dateofTransferred: "",
    proofOfTransfer: [],
  },
  revolving_fund: {
    Amount: "",
  },
  createdAt: new Date(),
  updatedAt: new Date(),
  financialProduct: "",
};
const fundingSources = [
  { matchkey: "loan", key: "loan", label: "Loan" },
  { matchkey: "grant", key: "grant", label: "Grant" },
  { matchkey: "farmer_self_investment", key: "self_investment", label: "Self Investment" },
  { matchkey: "revolving_fund", key: "revolving_fund", label: "Revolving Fund" },
];

const FileUploadComponent = ({
  section,
  formData,
  setFormData,
  isEditable,
  title,
  fileKey,
}) => {
  console.log(fileKey, section);
  const handleFileUpload = (event) => {
    const files = Array.from(event.target.files);
    if (files.length === 0) return;

    const newFiles = files.map((file) => URL.createObjectURL(file));

    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [fileKey]: [...(prev[section]?.[fileKey] || []), ...newFiles], // ✅ Corrected
      },
    }));
  };

  const deleteFile = (index) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [fileKey]: prev[section][fileKey].filter((_, i) => i !== index), // ✅ Corrected
      },
    }));
  };

  return (
    <Col md={9}>
      <label className="control-label is-imp">
        {title} (Files/SMS/Screenshots)
      </label>
      <div className="files-container">
        <div className="files">
          {formData[section]?.[fileKey]?.map((file, index) => (
            <div className="file-container" key={index}>
              <a download href={file} rel="noopener noreferrer" target="_blank">
                {"File " + (index + 1)}
              </a>
              {!isEditable && (
                <i
                  className="fa fa-times"
                  title="Delete File"
                  onClick={() => deleteFile(index)}
                ></i>
              )}
            </div>
          ))}
        </div>

        {!isEditable && (
          <>
            <input
              type="file"
              multiple
              accept="image/*, .pdf"
              style={{ display: "none" }}
              id={`file-upload-${section}-${fileKey}`}
              onChange={handleFileUpload}
            />
            <Button
              className="btn btn-danger brand-color-background"
              onClick={() =>
                document
                  .getElementById(`file-upload-${section}-${fileKey}`)
                  .click()
              }
            >
              Upload Files
            </Button>
          </>
        )}
      </div>
    </Col>
  );
};

export const AddCapitalModal = ({ closeModal, leadId, isEditable = false }) => {
  const [investmentType, setInvestmentType] = useState(''); // 'loan' or 'self'
  const [financialProduct, setFinancialProduct] = useState([]);
  const [formData, setFormData] = useState(initialState);
  const [selectedFP, setselectedFP] = useState(false);
  const [allBanks, setallBanks] = useState([]);
  const [confirmFinancial, setconfirmFinancial] = useState(false);
  const [collapsedSections, setCollapsedSections] = useState({});
  const [loading, setloading] = useState(false)
  const [errorObj, seterrorObj] = useState({
    loan: {},
    grant: {},
    self_investment: {},
  });

  useEffect(() => {
    fetchFinancialProduct();
    getAllBanks();

    if (leadId) {
      // Test Loan APIs with leadId
      console.log('--- TESTING LOAN APIS FOR USER:', leadId, '---');
      getLoansByUser(leadId)
        .then(data => console.log('User Loans Test Data:', data))
        .catch(err => console.error('User Loans Test Error:', err));

      getLoanDetails('LN-1766469743301', leadId)
        .then(data => console.log('Single Loan Test Data (LN-1766469743301) for User:', data))
        .catch(err => console.error('Single Loan Test Error (LN-1766469743301):', err));
    }
  }, [leadId]);
  const toggleCollapse = (section) => {
    setCollapsedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };
  const verifyIFSC = (section) => {
    let ifsc = formData[section].branchIFSC,
      errorObj2 = errorObj[section];
    let banks = formData[section].appliedToBank;
    if (ifsc) {
      fetch(
        process.env.REACT_APP_API_URL +
        "/api/v1/bank-branches/verify-ifsc/" +
        ifsc,
        {
          method: "GET",
          headers: {
            "x-auth-token": JSON.parse(readCookie("access_token")),
          },
        }
      )
        .then((data) => data.json())
        .then((data) => {
          if (data.status) {
            if (!data.bank || banks.indexOf(data.bank) === -1) {
              errorObj2["bankIFSC"] = "Please select the Bank with this IFSC";
              seterrorObj((prev) => ({
                ...prev,
                [section]: {
                  ...prev[section],
                  bankIFSC: errorObj2["bankIFSC"],
                },
              }));
            } else {
            }
          } else {
            errorObj2["bankIFSC"] = data.errorMsg;
            seterrorObj((prev) => ({
              ...prev,
              [section]: {
                ...prev[section],
                bankIFSC: errorObj2["bankIFSC"],
              },
            }));
          }
        })
        .catch((err) => {
          errorObj2["bankIFSC"] = "Invalid Bank IFSC";
          seterrorObj((prev) => ({
            ...prev,
            [section]: {
              ...prev[section],
              bankIFSC: errorObj2["bankIFSC"],
            },
          }));
        });
    } else {
      seterrorObj((prev) => ({
        ...prev,
        [section]: {
          ...prev[section],
          bankIFSC: '',
        },
      }));
    }
  };

  const getAllBanks = () => {
    fetch(process.env.REACT_APP_API_URL + "/api/v1/bank-branches/banks", {
      method: "GET",
      headers: {
        "x-auth-token": JSON.parse(readCookie("access_token")),
      },
    })
      .then((data) => data.json())
      .then((data) => {
        if (data.status) {
          setallBanks(data.allBanks);
        }
      });
  };
  const fetchFinancialProduct = () => {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/v1/humblebee/financial-product`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${JSON.parse(readCookie("access_token"))}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setFinancialProduct(data);
      })
      .catch((error) => console.error("Error fetching projects", error));
  };

  const checkAndImportValues = (fp) => {
    try {
      if (fp) {
        console.log(fp, fp.breakdown.loan.toString(), fp.loanTerms.tenureMonths.toString());
        if (fp.ticketSize == 'fixed') {
          if (fp.fundingSource.includes("loan")) {
            setFormData(prev => ({
              ...prev,
              loan: {
                ...prev.loan,
                Amount: fp.breakdown.loan.toString(),
                interestRate: fp.loanTerms.annualInterestRate.toString(),
                processingFee: fp.loanTerms.processingFeeValue.toString(),
                moratorium: fp.loanTerms.moratoriumMonths.toString(),
                Tenure: fp.loanTerms.tenureMonths.toString(),
                repaymentDuration: fp.loanTerms.repaymentFrequencyMonths.toString(),
              }
            }))
          }
          if (fp.fundingSource.includes('grant')) {
            setFormData(prev => ({
              ...prev,
              grant: {
                ...prev.grant,
                Amount: fp.breakdown.grant.toString(),
              }
            }))
          }
          if (fp.fundingSource.includes('revolving_fund')) {
            setFormData(prev => ({
              ...prev,
              revolving_fund: {
                ...prev.revolving_fund,
                Amount: fp.breakdown.revolvingFund.toString(),
              }
            }))
          }
        }
      }
    } catch (error) {
      console.log(error, 'err in importing data');
    }

  }


  const validateForm = () => {
    if (!selectedFP || !confirmFinancial) {
      toast.error("Please select a financial product and confirm its details.");
      return false;
    }

    const requiredFields = {
      loan: ["Amount", "interestRate", "processingFee", "moratorium", "Tenure", "repaymentDuration", "modeOfApplication", "dateOfApplication", "importantInfo", "status"],
      grant: ["Amount", "status"],
      self_investment: ["isTransferred"],
      revolving_fund: ["Amount",],
    };

    const statusBasedFields = {
      Sanctioned: {
        loan: ["dateOfSanction", "proofOfSanction"],
        grant: ["dateOfSanction", "proofOfSanction"],
      },
      Disbursed: {
        loan: ["dateOfDisbursement", "proofOfDisbursement", "disbursedTo", "disbursedAmount", "dateOfSanction", "proofOfSanction"],
        grant: ["dateOfDisbursement", "proofOfDisbursement", "disbursedTo", "disbursedAmount", "dateOfSanction", "proofOfSanction"],
      },
      Rejected: {
        loan: ["dateOfRejection"],
        grant: ["dateOfRejection"],
      },
      Transferred: {
        self_investment: ["Amount", "dateofTransferred", "proofOfTransfer"],
      },
    };

    for (const { matchkey, key } of fundingSources) {
      if (selectedFP.fundingSource.includes(matchkey)) {
        // Validate common required fields
        for (const field of requiredFields[key]) {
          if (!formData[key] || !formData[key][field]) {
            toast.error(`${field} is required for ${key.replace("_", " ")}`);
            return false;
          }
        }
        let status = ''
        // if(key=='loan'){
        //   if(formData[key].appliedToBank!==''){
        //     if(errorObj[key].bankIFSC||!formData[key].bankIFSC){
        //       toast.error('Enter the correct IFSC code');
        //       return false
        //     }
        //   }
        // }
        // Validate fields based on status
        if (key == 'self_investment') {
          status = formData[key]?.isTransferred;
        }
        else {
          status = formData[key]?.status;
        }

        if (status && statusBasedFields[status] && statusBasedFields[status][key]) {
          for (const field of statusBasedFields[status][key]) {
            if (!formData[key][field] || (Array.isArray(formData[key][field]) && formData[key][field].length === 0)) {
              toast.error(`${field} is required for ${key.replace("_", " ")} when status is ${status}`);
              return false;
            }
          }
        }
        else if (!status && key !== 'revolving_fund') {
          toast.error(`${'status'} is required for ${key.replace("_", " ")}`);

        }
      }
    }

    return true; // Return true only if no errors were found
  };




  const handleInputChange = (section, field, value) => {
    const nonNumbericKeys = [
      "modeOfApplication",
      "appliedToBank",
      "branchIFSC",
      "dateOfApplication",
      "dateOfSanction",
      "dateOfDisbursement",
      "dateOfRejection",
      "status",
      "importantInfo",
      "disbursedTo",
      "files",
      "proofOfSanction",
      "proofOfDisbursement",
      "isTransferred",
      "proofOfTransfer",
      "dateofTransferred",
    ];
    console.log(field, value, section);
    if (!nonNumbericKeys.includes(field)) {
      if (!/^\d*\.?\d*$/.test(value)) {
        toast.error("The entered value is not between 0 and 9.");
        return;
      }
    }
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));
  };

  const handleSubmit = () => {
    if (!validateForm()) {
      return
    }
    console.log(formData);
  }

  const renderSection = (section, label) => {
    console.log(section, label, formData[section]);
    const isLoan = section == "loan";
    if (section == "self_investment") {
      return (
        <>
          <Divider className="divider">
            <Button
              type="link"
              onClick={() => toggleCollapse(section)}
              style={{ fontSize: "16px" }}
            >
              {collapsedSections[section] ? <DownOutlined /> : <UpOutlined />}{" "}
              Application Details of {label}
            </Button>
          </Divider>{" "}
          {!collapsedSections[section] && (
            <>
              <Col md={6}>
                <label className="control-label is-imp">Select Status</label>
                <Select
                  size="large"
                  style={{ width: "100%" }}
                  value={formData[section].isTransferred}
                  onChange={(e) =>
                    handleInputChange(section, "isTransferred", e)
                  }
                  disabled={isEditable}
                >
                  <Option value="" disabled>
                    Select Status
                  </Option>
                  {["Transferred", "Yet to transfer", ,].map((status, idx) => (
                    <Option key={status} value={status}>
                      {status}
                    </Option>
                  ))}
                </Select>
              </Col>
              {formData[section].isTransferred == "Transferred" && (
                <>
                  <Row>
                    <Col md={4}>
                      <label className="control-label is-imp">
                        Date of Transfer
                      </label>
                      <input
                        className="form-control"
                        type="date"
                        max={new Date().toISOString().split("T")[0]}
                        value={
                          formData[section]?.dateofTransferred
                            ? new Date(formData[section].dateofTransferred)
                              .toISOString()
                              .split("T")[0]
                            : ""
                        }
                        onChange={(e) =>
                          handleInputChange(
                            section,
                            "dateofTransferred",
                            e.target.value
                          )
                        }
                        disabled={isEditable}
                      />
                    </Col>

                    <Col md={6}>
                      <label className="control-label is-imp">
                        {label} Amount
                      </label>
                      <Input
                        type="text"
                        placeholder={`${label} Amount`}
                        value={formData[section].Amount}
                        className="form-control"
                        onChange={(e) =>
                          handleInputChange(section, "Amount", e.target.value)
                        }
                        disabled={isEditable}
                      />
                    </Col>
                  </Row>

                  <Col md={9}>
                    <FileUploadComponent
                      fileKey="proofOfTransfer"
                      formData={formData}
                      setFormData={setFormData}
                      section={section}
                      isEditable={isEditable}
                      title={"Proof of Transfer"}
                    />
                  </Col>
                </>
              )}
            </>
          )}
        </>
      );
    }
    if (section == "revolving_fund") {
      return (
        <>
          <Divider className="divider">
            <Button
              type="link"
              onClick={() => toggleCollapse(section)}
              style={{ fontSize: "16px" }}
            >
              {collapsedSections[section] ? <DownOutlined /> : <UpOutlined />}{" "}
              Application Details of {label}
            </Button>
          </Divider>{" "}
          {!collapsedSections[section] && (
            <>
              <Row>
                <Col md={4}>
                  <label className="control-label is-imp">{label} Amount</label>
                  <Input
                    type="text"
                    placeholder={`${label} Amount`}
                    value={formData[section].Amount}
                    className="form-control"
                    onChange={(e) =>
                      handleInputChange(section, "Amount", e.target.value)
                    }
                    disabled={isEditable}
                  />
                </Col>
              </Row>
            </>
          )}
        </>
      );
    }

    return (
      <>
        <Divider className="divider">
          <Button
            type="link"
            onClick={() => toggleCollapse(section)}
            style={{ fontSize: "16px" }}
          >
            {collapsedSections[section] ? <DownOutlined /> : <UpOutlined />}{" "}
            Application Details of {label}
          </Button>
        </Divider>
        {!collapsedSections[section] && (
          <>
            <Row>
              <Col md={4}>
                <label className="control-label is-imp">
                  {label == "Loan" ? "Principle" : label} Amount
                </label>
                <Input
                  type="text"
                  placeholder={`${label} Amount`}
                  value={formData[section].Amount}
                  className="form-control"
                  onChange={(e) =>
                    handleInputChange(section, "Amount", e.target.value)
                  }
                  disabled={isEditable}
                />
              </Col>
              {isLoan && (
                <>
                  <Col md={4}>
                    <label className="control-label is-imp">
                      {" "}
                      Interest Rate
                    </label>
                    <Input
                      type="text"
                      placeholder={`Interest Rate`}
                      value={formData[section].interestRate}
                      className="form-control"
                      onChange={(e) => {
                        const value = e.target.value
                        const c = parseFloat(value, 10) || 0;
                        if (c > 50) {
                          toast.error("Interest Rate should not be more than 50%.");
                          return;
                        }
                        handleInputChange(
                          section,
                          "interestRate",
                          value
                        )
                      }
                      }
                      disabled={isEditable}
                    />
                  </Col>
                  <Col md={4}>
                    <label className="control-label is-imp">
                      Processing Fee
                    </label>
                    <Input
                      type="text"
                      placeholder={`Processing Fee`}
                      value={formData[section].processingFee}
                      className="form-control"
                      onChange={(e) =>
                        handleInputChange(
                          section,
                          "processingFee",
                          e.target.value
                        )
                      }
                      disabled={isEditable}
                    />
                  </Col>
                </>
              )}
            </Row>
            {isLoan && (
              <Row>
                <Col md={4}>
                  <label className="control-label is-imp">
                    {" "}
                    Moratorium (In Months)
                  </label>
                  <Input
                    type="text"
                    placeholder={`Moratorium`}
                    value={formData[section].moratorium}
                    className="form-control"
                    onChange={(e) =>
                      handleInputChange(section, "moratorium", e.target.value)
                    }
                    disabled={isEditable}
                  />
                </Col>
                <Col md={4}>
                  <label className="control-label is-imp">
                    Tenure (In Months)
                  </label>
                  <Input
                    type="text"
                    placeholder={`${label} Tenure`}
                    value={formData[section].Tenure}
                    className="form-control"
                    onChange={(e) =>
                      handleInputChange(section, "Tenure", e.target.value)
                    }
                    disabled={isEditable}
                  />
                </Col>
                <Col md={4}>
                  <label className="control-label is-imp">
                    Repayment Duration (In Months)
                  </label>
                  <Input
                    type="text"
                    placeholder={`${label} Repayment Duration`}
                    value={formData[section].repaymentDuration}
                    className="form-control"
                    onChange={(e) =>
                      handleInputChange(
                        section,
                        "repaymentDuration",
                        e.target.value
                      )
                    }
                    disabled={isEditable}
                  />
                </Col>
              </Row>
            )}
            <Col md={4}>
              <label className="control-label is-imp">Select Status</label>
              <Select
                size="large"
                style={{ width: "100%" }}
                value={formData[section].status}
                onChange={(e) => handleInputChange(section, "status", e)}
                disabled={isEditable}
              >
                <Option value="" disabled>
                  Select Status
                </Option>
                {[
                  "Funded",
                  "Applied",
                  "Re-applied",
                  "Rejected",
                  "Sanctioned",
                  "Disbursed",
                ].map((status) => (
                  <Option key={status} value={status}>
                    {status}
                  </Option>
                ))}
              </Select>
            </Col>

            <Row>
              <Col md={4}>
                <label className="control-label is-imp">
                  Date of Application
                </label>
                <input
                  className="form-control"
                  type="date"
                  max={new Date().toISOString().split("T")[0]}
                  value={
                    formData[section]?.dateOfApplication
                      ? new Date(formData[section].dateOfApplication)
                        .toISOString()
                        .split("T")[0]
                      : ""
                  }
                  onChange={(e) =>
                    handleInputChange(
                      section,
                      "dateOfApplication",
                      e.target.value
                    )
                  }
                  disabled={isEditable}
                />
              </Col>

              {isLoan && (
                <>
                  <Col md={4}>
                    <label className="control-label is-imp">
                      Select Mode of Application
                    </label>
                    <Select
                      size="large"
                      style={{ width: "100%" }}
                      value={formData[section].modeOfApplication}
                      onChange={(e) =>
                        handleInputChange(section, "modeOfApplication", e)
                      }
                      disabled={isEditable}
                    >
                      <Option value="" disabled>
                        Mode of Application
                      </Option>
                      <Option value="Online">Online</Option>
                      <Option value="Offline">Offline</Option>
                    </Select>
                  </Col>

                  <Col md={4}>
                    <label className="control-label">Loan Bank (if any)</label>
                    <Select
                      size="large"
                      style={{ width: "100%" }}
                      value={formData[section].appliedToBank}
                      onChange={(e) =>
                        handleInputChange(section, "appliedToBank", e)
                      }
                      disabled={isEditable}
                    >
                      <Option value="" disabled>
                        Select Loan Bank
                      </Option>
                      {allBanks.map((bank, index) => (
                        <Option key={index} value={bank}>
                          {bank}
                        </Option>
                      ))}
                    </Select>
                  </Col>
                </>
              )}
            </Row>

            {isLoan && formData[section].appliedToBank && (
              <Col md={3}>
                <label className="control-label is-imp">Branch IFSC</label>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Branch IFSC"
                  value={formData[section].branchIFSC}
                  onBlur={(e) => verifyIFSC(section)}
                  onChange={(e) =>
                    handleInputChange(section, "branchIFSC", e.target.value)
                  }
                  disabled={isEditable}
                />
                {errorObj[section].bankIFSC && (
                  <div
                    style={{
                      color: "#F68787",
                      fontSize: "13px",
                      fontWeight: 600,
                    }}
                  >
                    {errorObj[section].bankIFSC} {section}
                  </div>
                )}
              </Col>
            )}

            <Col md={12}>
              <label className="control-label is-imp">
                Application Details (Portal Login, Bank Contact, Conversation
                Summary)
              </label>
              <textarea
                className="form-control"
                value={formData[section].importantInfo}
                onChange={(e) =>
                  handleInputChange(section, "importantInfo", e.target.value)
                }
                disabled={isEditable}
              />
            </Col>

            {formData[section].status == "Rejected" && (
              <>
                <Divider className="divider">Rejection Details</Divider>
                <Col md={4}>
                  <label className="control-label is-imp">
                    Date of Rejection
                  </label>
                  <input
                    className="form-control"
                    type="date"
                    style={{ width: "100%" }}
                    min={
                      formData[section]?.dateOfApplication
                        ? new Date(formData[section].dateOfApplication)
                          .toISOString()
                          .split("T")[0]
                        : ""
                    }
                    max={new Date().toISOString().split("T")[0]}
                    placeholder="Date of Rejection"
                    value={
                      formData[section]?.dateOfRejection
                        ? new Date(formData[section].dateOfRejection)
                          .toISOString()
                          .split("T")[0]
                        : ""
                    }
                    onChange={(e) =>
                      handleInputChange(
                        section,
                        "dateOfRejection",
                        e.target.value
                      )
                    }
                    disabled={isEditable}
                  />
                </Col>
              </>
            )}

            {(formData[section].status == "Sanctioned" ||
              formData[section].status == "Disbursed") && (
                <>
                  <Divider className="divider">Sanction Details</Divider>

                  <Col md={3}>
                    <label className="control-label is-imp">
                      Date of Sanction
                    </label>
                    <input
                      className="form-control"
                      type="date"
                      style={{ width: "100%" }}
                      placeholder="Date of Sanction"
                      max={new Date().toISOString().split("T")[0]}
                      value={
                        formData[section]?.dateOfSanction
                          ? new Date(formData[section].dateOfSanction)
                            .toISOString()
                            .split("T")[0]
                          : ""
                      }
                      disabled={isEditable}
                      min={
                        formData[section]?.dateOfApplication
                          ? new Date(formData[section].dateOfApplication)
                            .toISOString()
                            .split("T")[0]
                          : ""
                      }
                      onChange={(e) =>
                        handleInputChange(
                          section,
                          "dateOfSanction",
                          e.target.value
                        )
                      }
                    />
                  </Col>

                  <Col md={9}>
                    <FileUploadComponent
                      fileKey="proofOfSanction"
                      formData={formData}
                      setFormData={setFormData}
                      section={section}
                      isEditable={isEditable}
                      title={"Proof of Sanction"}
                    />
                  </Col>
                </>
              )}

            {formData[section].status == "Disbursed" && (
              <>
                <Divider className="divider">Disbursement Details</Divider>
                <Row>
                  <Col className="variable-width">
                    <label className="control-label is-imp">
                      Date of Disbursement
                    </label>
                    <input
                      className="form-control"
                      type="date"
                      style={{ width: "100%" }}
                      placeholder="Date of Disbursement"
                      max={moment().format("YYYY-MM-DD")}
                      disabled={isEditable}
                      min={
                        formData[section]?.dateOfDisbursement
                          ? new Date(formData[section].dateOfDisbursement)
                            .toISOString()
                            .split("T")[0]
                          : ""
                      }
                      value={
                        formData[section]?.dateOfDisbursement
                          ? new Date(formData[section].dateOfDisbursement)
                            .toISOString()
                            .split("T")[0]
                          : ""
                      }
                      onChange={(e) =>
                        handleInputChange(
                          section,
                          "dateOfDisbursement",
                          e.target.value
                        )
                      }
                    />
                  </Col>
                  <Col md={4}>
                    <label className="control-label is-imp">
                      Select Disbursed To
                    </label>
                    <Select
                      size="large"
                      style={{ width: "100%" }}
                      value={formData[section]?.disbursedTo}
                      onChange={(e) =>
                        handleInputChange(section, "disbursedTo", e)
                      }
                      disabled={isEditable}
                    >
                      <Option value="" disabled>
                        Disbursed to
                      </Option>
                      <Option value="Candidate">Candidate</Option>
                      <Option value="Vendor">Vendor</Option>
                      <Option value="Both">Both</Option>
                    </Select>
                  </Col>
                </Row>
                <Col md={12}>
                  <FileUploadComponent
                    fileKey="proofOfDisbursement"
                    formData={formData}
                    setFormData={setFormData}
                    section={section}
                    isEditable={isEditable}
                    title={"Proof of Disbursement"}
                  />
                  <Row>
                    <Col md={4}>
                      <label className="control-label is-imp">
                        Disbursed Amount
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Actual Amount Disbursed to the account"
                        name="disbursedAmount"
                        onChange={(e) =>
                          handleInputChange(
                            section,
                            "disbursedAmount",
                            e.target.value
                          )
                        }
                        value={formData[section].disbursedAmount}
                        disabled={isEditable}
                      />
                    </Col>
                    {!isLoan && <Col md={4}>
                      <label className="control-label is-imp">
                        Annual Interest Rate %
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        min={0}
                        max={30}
                        value={formData[section].disbursedInterestPercentage}
                        placeholder="Disbursed Interest Percentage (Between 0% and 30%)"
                        name="disbursedInterestPercentage"
                        onChange={(e) => {
                          const value = e.target.value
                          const c = parseFloat(value, 10) || 0;
                          if (c > 50) {
                            toast.error("Interest Rate should not be more than 50%.");
                            return;
                          }
                          handleInputChange(
                            section,
                            "disbursedInterestPercentage",
                            value
                          )
                        }
                        }
                        disabled={isEditable}
                      />{" "}
                    </Col>}
                  </Row>
                </Col>
              </>
            )}
          </>
        )}
      </>
    );
  };


  return (
    <div>
      {/* Investment Type Selection */}
      <Row style={{ marginBottom: 20 }}>
        <Col md={12}>
          <label className="control-label is-imp" style={{ fontWeight: 600, marginBottom: 10, display: 'block' }}>
            Select Type of Investment:
          </label>
          <div style={{ display: "flex", gap: 20 }}>
            <label style={{ cursor: 'pointer' }}>
              <input
                type="radio"
                name="investmentType"
                value="loan"
                checked={investmentType === "loan"}
                onChange={() => {
                  setInvestmentType("loan");
                  // Reset selections when changing type
                  setselectedFP(false);
                  setconfirmFinancial(false);
                }}
                disabled={isEditable}
              />
              &nbsp;Loan
            </label>

            <label style={{ cursor: 'pointer' }}>
              <input
                type="radio"
                name="investmentType"
                value="self"
                checked={investmentType === "self"}
                onChange={() => {
                  setInvestmentType("self");
                  // Reset selections when changing type
                  setselectedFP(false);
                  setconfirmFinancial(false);
                }}
                disabled={isEditable}
              />
              &nbsp;Self Investment
            </label>
          </div>
        </Col>
      </Row>

      {/* Financial Product Selection - Only show for Loan */}
      {investmentType === 'loan' && (
        <Col md={6}>
          <label className="control-label is-imp">Select Financial Product</label>
          <Select
            size="large"
            showSearch
            style={{ width: "100%" }}
            placeholder="Select from list"
            value={selectedFP?._id || null}
            onChange={(e) => {
              {
                let fp = financialProduct.find((it) => it._id == e);
                console.log(fp);
                setselectedFP(fp);
                setconfirmFinancial(false);
              }
            }}
            disabled={isEditable}
          >
            <Option value="" disabled>
              Select Financial Product
            </Option>
            {financialProduct.map((it) => (
              <Option key={it._id} value={it._id}>
                {it.uniqueID}
              </Option>
            ))}
          </Select>
        </Col>
      )}
      {selectedFP && !confirmFinancial ? (
        <>
          <ConfirmFinancialProductForm
            handleCloseModal={(e) => {
              setconfirmFinancial(true)
              checkAndImportValues(selectedFP)
            }}
            initialData={selectedFP}
          />
        </>
      ) : null}

      {/* Show forms based on investment type */}
      {/* For Loan type - show forms based on selected financial product */}
      {investmentType === 'loan' && selectedFP &&
        confirmFinancial &&
        selectedFP.fundingSource.includes("loan") &&
        renderSection("loan", "Loan")}
      {investmentType === 'loan' && selectedFP &&
        confirmFinancial &&
        selectedFP.fundingSource.includes("grant") &&
        renderSection("grant", "Grant")}
      {investmentType === 'loan' && selectedFP &&
        confirmFinancial &&
        selectedFP.fundingSource.includes("farmer_self_investment") &&
        renderSection("self_investment", "Self Investment")}
      {investmentType === 'loan' && selectedFP &&
        confirmFinancial &&
        selectedFP.fundingSource.includes("revolving_fund") &&
        renderSection("revolving_fund", "Revolving Fund")}

      {/* For Self Investment type - show self investment form directly */}
      {investmentType === 'self' && renderSection("self_investment", "Self Investment")}
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        gap: 10,
        marginTop: 20,
        borderTop: '0.5px solid #CBCBCB',
        padding: '20px 0 0 0'
      }}>

        <Button
          className="btn brand-color-background"
          onClick={handleSubmit}
          disabled={
            isEditable || loading
          }
        >
          Save
        </Button>
        <Button
          className="btn btn-danger brand-color-background"
          onClick={closeModal}
          disabled={
            isEditable || loading
          }
        >
          Cancel
        </Button>
      </div>
    </div>

  );
};
